import { materialTypeEnum } from '@/global/enum/product'
import { useAppStore } from '@/stores/appStore'

/**
 * 基于用户信息的权限限制
 */
export function useUserInfoLimit() {
  const userInfo = useAppStore((state) => state.userInfo)

  function limitSrmProductType(oldSrmProductType: any) {
    if (
      !userInfo?.permissionNameList ||
      userInfo.permissionNameList.length < 1
    ) {
      return undefined
    }
    if (userInfo.permissionNameList.length > 1) {
      return oldSrmProductType
    }
    if (userInfo.permissionNameList?.[0] === '电商供应商') {
      return materialTypeEnum.getValueByLabel('电商供应商物料')
    }
    if (userInfo.permissionNameList?.[0] === '自营供应商') {
      return materialTypeEnum.getValueByLabel('供应商物料')
    }
    // 没有匹配的项目
    return oldSrmProductType
  }
  return {
    limitSrmProductType,
  }
}
import { materialTypeEnum } from '@/global/enum/product'
import { useAppStore } from '@/stores/appStore'

/**
 * 基于用户信息的权限限制
 */
export function useUserInfoLimit() {
  const userInfo = useAppStore((state) => state.userInfo)

  function limitSrmProductType(oldSrmProductType: any) {
    if (
      !userInfo?.permissionNameList ||
      userInfo.permissionNameList.length < 1
    ) {
      return undefined
    }
    if (userInfo.permissionNameList.length > 1) {
      return oldSrmProductType
    }
    if (userInfo.permissionNameList?.[0] === '电商供应商') {
      return materialTypeEnum.getValueByLabel('电商供应商物料')
    }
    if (userInfo.permissionNameList?.[0] === '自营供应商') {
      return materialTypeEnum.getValueByLabel('供应商物料')
    }
    // 没有匹配的项目
    return oldSrmProductType
  }
  return {
    limitSrmProductType,
  }
}
